import { isTauri } from "@tauri-apps/api/core"

export type RuntimeMode = "web" | "native-shell"

export function getRuntimeMode(): RuntimeMode {
        if (isTauri()) {
                return "native-shell"
        }

        return "web"
}

export function isNativeMobileRuntime(): boolean {
        return getRuntimeMode() === "native-shell"
                && /Android|iPhone|iPad|iPod/i.test(globalThis.navigator?.userAgent ?? "")
}
